// 01/10/2026 (perf): o carrossel de avaliações (loop + autoplay) só é inicializado quando se aproxima da tela.
const reviewSwiperContainer = document.querySelector('.reviews-section .swiper-container');
function mcInitReviewSwiper() {
  if (!reviewSwiperContainer || reviewSwiperContainer.dataset.mcInit) return;
  reviewSwiperContainer.dataset.mcInit = '1';
  new Swiper(reviewSwiperContainer, {
    slidesPerView: 5,
    spaceBetween: 8,
    centeredSlides: true,
    initialSlide: 4,
    grabCursor: true,
    loop: true,
    loopAdditionalSlides: 4,
    loopedSlides: 10,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    breakpoints: {
      0: {
        slidesPerView: "auto",
        centeredSlides: true,
      },
      480: {
        slidesPerView: "auto",
        centeredSlides: true,
      },
      768: {
        slidesPerView: 3,
        centeredSlides: false
      },
      1024: {
        slidesPerView: 5,
        centeredSlides: true
      }
    }
  });
}
if (reviewSwiperContainer) {
  if ('IntersectionObserver' in window) {
    var mcRevObs = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { mcInitReviewSwiper(); mcRevObs.disconnect(); }
    }, { rootMargin: '300px 0px' });
    mcRevObs.observe(reviewSwiperContainer);
  } else {
    mcInitReviewSwiper();
  }
}
